import type { JSX } from 'react';
import { RefrigerationUnitGeneralInfoSection } from './sections/GeneralInfoSection';

export function RefrigerationUnitCoreForm(): JSX.Element {
  return (
    <div className="space-y-8">
      <RefrigerationUnitGeneralInfoSection />
    </div>
  );
}
